import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Symbol.module.scss'

/**
 * The `Symbol`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Symbol = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.symbol, styles.symbol]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Symbol.displayName = 'Symbol'

/** @type {object} */
Symbol.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Symbol.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Symbol)
